import { MachineGateway } from "./../../../models/machine";
import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import { RecordFileTemplateOptions } from "../../../../../../app/records/forms/formly/types";
import { FormViewController } from "../../../../../../app/records/forms/formView/controller";
//import repeatController from "../../../../../ui-formly/types/repeater/controller";

const template = require("!html-loader!./index.html").default;

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../../app/records/forms/formView/service";
import fieldHelpers, {
  headerField,
} from "../../../../../../app/ui-formly/fieldHelpers";
import { MachineConfigurationViewGateway } from "../../../models/machineConfiguration";
import { cloneDeep } from "lodash";

interface MachinesWarehouseFormModel {
  MachineChanges?: MachineWarehouseMachine[];
  Date?: Date;
  Files?: File[];
}

interface MachineWarehouseMachine {
  MachineId: number;
}
export class MachinesWarehouseViewController implements IOnInit {
  static $inject = [FormViewServiceName, "$state"];

  formFields!: IFieldArray;
  machineInfo!: { machineConfigurations: MachineConfigurationViewGateway[] };

  /* start bindings */
  readonly machineConfigurations!: MachineConfigurationViewGateway[];
  /* end binding */

  model!: MachinesWarehouseFormModel;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService
  ) {}

  private initializeFormFields(machineInfo: {
    machineConfigurations: MachineConfigurationViewGateway[];
  }) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Project Date",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "ProjectNumber",
            name: "ProjectNumber",
            label: "Project Number",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "WarehouseLocation",
            name: "WarehouseLocation",
            label: "Location",
            required: true,
          }),
        ],
        4
      ),
      fieldHelpers.headerField({
        headerText: "Machines",
        key: "MachinesHeader",
      }),
      {
        key: "machineConfigurations",
        model: machineInfo,
        template: require("!html-loader!../sharedTemplates/machineList.html")
          .default,
      },
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({ headerText: "Notes", key: "NotesHeader" }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    this.model = {
      Date: undefined,
      Files: [],
      MachineChanges: this.machineConfigurations.map((mc) => {
        return { MachineId: mc.MachineId };
      }),
    };
    this.machineInfo = {
      machineConfigurations: cloneDeep(this.machineConfigurations),
    };
    this.initializeFormFields(this.machineInfo);
  }

  async submit(formViewController: FormViewController): Promise<void> {
    await this.formViewService.submitForm({
      url: `/api/machines/warehouse`,
      formObject: this.model,
      formViewController,
      method: "post",
    });

    await this.$state.go("^.grid", undefined, { reload: true });
  }

  async cancel(): Promise<void> {
    await this.$state.go("^.grid");
  }
}
